import { render } from "./LearningInsights.vue?vue&type=template&id=763a74d2&scoped=true"
import script from "./LearningInsights.vue?vue&type=script&lang=js"
export * from "./LearningInsights.vue?vue&type=script&lang=js"

import "./LearningInsights.vue?vue&type=style&index=0&id=763a74d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763a74d2"]])

export default __exports__